import { motion } from "framer-motion";
import { SectionHead } from "@/components/site/SectionHead";
import { QuoteButton } from "@/components/site/Cta";
import { PROCESS } from "@/content/site";

export const Process = () => (
  <section data-testid="process-section" className="relative overflow-hidden bg-[#0b0c0e] py-24 sm:py-32">
    <div className="pointer-events-none absolute inset-0 grid-lines opacity-40 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHead index="04" eyebrow="The Process" lines={["Solar made", "simple"]} />
        <QuoteButton testId="process-cta-start">Start Your Project</QuoteButton>
      </div>
      <div className="relative mt-16">
        <svg className="pointer-events-none absolute left-0 right-0 top-7 hidden h-2 w-full lg:block" preserveAspectRatio="none" viewBox="0 0 100 2" aria-hidden="true">
          <line x1="0" y1="1" x2="100" y2="1" stroke="rgba(245,166,35,0.55)" strokeWidth="0.3" className="energy-flow" vectorEffect="non-scaling-stroke" />
        </svg>
        <ol className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {PROCESS.map((p, i) => (
            <motion.li key={p.n} data-testid={`process-step-${p.n}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }} className="relative">
              <div className="relative z-10 grid h-14 w-14 place-items-center rounded-full border border-amber-400/50 bg-[#0b0c0e] font-mono text-sm text-amber-400 shadow-[0_0_30px_-6px_rgba(245,166,35,0.6)]">{p.n}</div>
              <div className="card-lux mt-6 rounded-2xl p-7">
                <h3 className="text-base font-semibold uppercase tracking-tight text-white">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-300">{p.text}</p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
